<template>
	<div class="Floorbanner">
	  <mt-swipe v-bind:style="getBannerStyle" :showIndicators="isShowIndicators" class="indexbanners">
	    <mt-swipe-item v-for="(item, index) in items" :key="index">
	      <img :style="getBannerStyle" v-lazy="item.adv_code" v-if='item.adv_code' @click="goAdUrl(item)">
	      <!--<img :style="getBannerStyle" src="../../../assets/image/home/default_image_banner.png" v-else>-->
	    </mt-swipe-item>
	  </mt-swipe>
  </div>
</template>

<script>
export default {
  name: 'IndexBanner',
  data () { 	
    return {
    }
  },
  props: ['items'],
  created: function(){
  	
  },
  computed: {
    getBannerStyle: function () {
      const { width } = window.screen
      let itemWidth = width
      let itemHeight = width/2*1.81
      
      return {
        width: 100 + '%',
        height: itemHeight + 'px',
        'max-height':50+'rem'
      }
    },
    isShowIndicators () {
      if (this.items && this.items.length > 1) {
        return true
      }
      return false
    }
  },
  methods: { 	
    goAdUrl (item) {
    	//暂时隐藏，都跳转导云展
//  	this.$router.push({ 'name': 'HomeLiveIndex' })
//    switch (item.adv_type) {
//      case 'goods':
//        this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: item.adv_typedate } })
//        break
//      case 'store':
//        this.$router.push({ name: 'HomeStoredetail', query: { id: item.adv_typedate } })
//        break
//      case 'article':
//        this.$router.push({ name: 'HomeArticledetail', query: { article_id: item.adv_typedate } })
//        break
//      case 'url':
//        window.location.href=item.adv_typedate
//        break  
//    }
    }
  }
}
</script>

<style>
.Floorbanner .mint-swipe-indicator{width: 12px;height: 12px;background-color: #fff;opacity: 1;margin-top: 4px;float: left;border: 1px solid #FF0000;}
body .Floorbanner .mint-swipe{overflow: inherit;}
body .Floorbanner .mint-swipe-items-wrap{border-radius: 0px;}
body .Floorbanner .indexbanners .mint-swipe-indicators .is-active{background-color: #FF0000;opacity: 1;margin-top: 4px;width: 12px;height: 12px;border-color: #fff;}
body .Floorbanner .indexbanners .mint-swipe-indicators{bottom: 0.7rem;}

</style>
